import axios from 'axios';
import cookie from 'react-cookies';

const instance = axios.create();

instance.interceptors.request.use((config) => {
  const accessToken = cookie.load('accessToken');

  // Check if the request is going to functions.php
  if (
    config.url?.split('?')[0] ===
    `${process.env.VITE_APP_PHP_DOMAIN}/rest/functions.php`
  ) {
    // Check to see if a user has an accessToken cookie set
    if (accessToken) {
      // Check if authorization header is already present
      if (!config.headers.authorization && !config.headers.Authorization) {
        config.headers.authorization = accessToken;
      }
      // Check if withCredentials header is already present
      if (!config.withCredentials) {
        config.withCredentials = true;
      }
    }
  }
  return config;
});

export default instance;
